/**
 * Fleet UI integration
 *
 * This module integrates the fleet-ui package with the main app.
 */

 import React, { lazy } from 'react';
 import { Route } from 'react-router-dom';
 import PrivateRoute from './routes/PrivateRoute';
 
 import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-material.css';
 import './utils/aggrid/ag-grid-styles.scss';
 
 const Dashboard = lazy(() => import('./fleet-ui/routes/dashboard/Dashboard'));
 const Summary = lazy(() => import('./fleet-ui/routes/summaryDashboard/SummaryDashboard.jsx'));
 const FleetOrder = lazy(() =>
   import('./fleet-ui/routes/fleetOrder/FleetOrder')
 );
 const FleetOrderView = lazy(() =>
   import('./fleet-ui/routes/fleetOrder/view/FleetOrderView')
 );
 const Equipment = lazy(() => import('./fleet-ui/routes/equipment/Equipment'));
 const EquipmentView = lazy(() =>
   import('./fleet-ui/routes/equipment/view/EquipmentView')
 );
 const Stock = lazy(() => import('./fleet-ui/routes/stock/Stock'));
 const StockView = lazy(() => import('./fleet-ui/routes/stock/view/StockView'));
 const ConstructionUnits = lazy(() =>
   import('./fleet-ui/routes/constructionUnits/ConstructionUnits')
 );
 const Warehouse = lazy(() => import('./fleet-ui/routes/warehouse/Warehouse'));
 const WarehouseView = lazy(() =>
   import('./fleet-ui/routes/warehouse/view/WarehouseView')
 );
 const UnitOfMeasure = lazy(() =>
   import('./fleet-ui/routes/unitOfMeasure/UnitOfMeasure')
 );
 const ListCode = lazy(() => import('./fleet-ui/routes/listCode/ListCode'));
 const FuelCode = lazy(() => import('./fleet-ui/routes/fuelCode/FuelCode'));
 const GLAccount = lazy(() => import('./fleet-ui/routes/glAccount/GLAccount'));
 const Task = lazy(() => import('./fleet-ui/routes/task/Task'));
 const TaskList = lazy(() => import('./fleet-ui/routes/taskList/TaskList'));
 const PartKit = lazy(() => import('./fleet-ui/routes/partKit/PartKit'));
const Import = lazy(() => import('./fleet-ui/routes/Import/ImportCsv'));
const Mechanics = lazy(() => import('./fleet-ui/routes/mechanics/Mechanics'));
 //const CSVImport = lazy(() => import('./fleet-ui/routes/Import/CSVImport'));
 const CSVImportFinal = lazy(() => import('./fleet-ui/routes/Import/CSVImportFinal'));  

 const RepairCode = lazy(() => import('./fleet-ui/routes/repairCode/RepairCode'));
 //const ImportView = lazy(() => import('./fleet-ui/routes/Import/ImportSideSheet'));
 
 export const routes = {
   dashboard: {
     link: '/',
     component: Dashboard,
   },
   summary: {
    link: '/Summary',
    component: Summary,
  },
   fleetOrder: {
     name: 'Fleet Order',
     link: '/FleetOrder',
     component: FleetOrder,
   },
   equipment: {
     name: 'Equipment',
     link: '/Equipment',
     component: Equipment,
   },
   stock: {
     name: 'Stock',
     link: '/Stock',
     component: Stock,
   },
   constructionUnits: {
     name: 'Kits',
     link: '/Kits',
     component: ConstructionUnits,
   },
   glAccount: {
     name: 'GL Account',
     link: '/GLAccount',
     component: GLAccount,
   },
   task: {
     name: 'Task',
     link: '/Task',
     component: Task,
   },
   taskList: {
     name: 'Task List',
     link: '/TaskList',
     component: TaskList,
   },
   partKit: {
     name: 'Service Kit',
     link: '/ServiceKit',
     component: PartKit,
   },
   fuelCode: {
     name: 'Fuel Code',
     link: '/FuelCode',
     component: FuelCode,
   },
   listCode: {
     name: 'List Code',
     link: '/ListCode',
     component: ListCode,
   },
   repairCode: {
     name: 'Repair Code',
     link: '/RepairCode',
     component: RepairCode,
   },
   unitOfMeasure: {
     name: 'Unit of Measure',
     link: '/UnitofMeasure',
     component: UnitOfMeasure,
   },
   warehouse: {
     name: 'Warehouse',
     link: '/Warehouse',
     component: Warehouse,
   },
   import: {
     name: 'Import',
     link: '/Import',
     component: Import,
     },
   import: {
     name: 'Mechanics',
     link: '/Mechanics',
     component: Mechanics,
    },
   /* csvImport: {
     name: 'CSVImport',
     link: '/CSVImport',
     component: CSVImport,
   }, */
   csvImportFinal:{
     name: 'CSVImportFinal',
     link: '/CSVImportFinal',
     component: CSVImportFinal,
   },
   viewStock: {
     link: '/Stock/:stockId',
     component: StockView,
   },
   viewEquipment: {
     link: '/Equipment/:equipmentId',
     component: EquipmentView,
   },
   viewFleetOrder: {
     link: '/FleetOrder/:fleetOrderId',
     component: FleetOrderView,
   },
   viewWarehouse: {
     link: '/Warehouse/:warehouseId',
     component: WarehouseView,
     },
 };
 
 export const FleetRoutes = () =>
   Object.entries(routes).map(([key, route]) => (
     <PrivateRoute key={key} exact path={route.link} component={route.component} />
   ));
 